<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <Toast />
                <div class="p-grid">
                    <div class="p-col-12 p-md-2">
                        <span class="p-float-label">
                            <Dropdown :showClear="true" style="width: 100%" v-model="shopsModel" :options="shops" optionLabel="name" :filter="!this.isMobile()" />
                            <label>{{ $t('dropdown.placeholder.shop') }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-2">
                        <span class="p-float-label">
                            <Dropdown :showClear="true" style="width: 100%" v-model="yearModel" :options="yearsDdl" optionLabel="year" :filter="!this.isMobile()" />
                            <label>{{ $t('dropdown.placeholder.year') }}</label>
                        </span>
                    </div>
                    <div class="p-col-6 p-md-7 p-text-right"><Button type="button" :label="$t('buttons.show')" class="p-button-raised p-button-success" @click="showReport()" /></div>
                    <div class="p-col-6 p-md-1 p-text-right">
                        <Button type="button" :label="$t('buttons.savePdf')" :loading="showDownloadingData" icon="pi pi-download" class="p-button-raised p-button-info" @click="savePdf()" />
                    </div>
                </div>
                <DataTable v-show="showReportData" :value="reportData" v-model:expandedRows="expandedRows" ref="datatable" responsiveLayout="scroll">
                    <Column>
                        <template #body="slotProps">
                            <span class="indexColumn">{{ slotProps.index + 1 }}</span>
                        </template>
                    </Column>
                    <Column :expander="true" headerStyle="width: 3rem" />
                    <Column field="month" :header="$t('decont.month')">
                        <template #body="{ data }">{{ $t('months.' + data.month) }} </template></Column
                    >
                    <Column field="solds" :header="$t('decont.totalIn')">
                        <template #body="{ data }">{{ formatCurrency(data.solds.in) }} </template></Column
                    >
                    <Column field="solds" :header="$t('decont.inTax')">
                        <template #body="{ data }">{{ formatCurrency(data.solds.inTax) }} </template></Column
                    >
                    <Column field="solds" :header="$t('decont.totalOut')">
                        <template #body="{ data }">{{ formatCurrency(data.solds.out) }} </template></Column
                    >
                    <Column field="solds" :header="$t('decont.outTax')">
                        <template #body="{ data }">{{ formatCurrency(data.solds.outTax) }} </template></Column
                    >
                    <Column field="solds" :header="$t('decont.profit')">
                        <template #body="{ data }">{{ formatCurrency(data.solds.profit + data.solds.outTax) }} </template></Column
                    >
                    <Column field="solds" :header="$t('decont.profitNet')">
                        <template #body="{ data }">{{ formatCurrency(data.solds.profit) }} </template></Column
                    >
                    <Column field="solds" :header="$t('decont.invoiceAmount')">
                        <template #body="{ data }">{{ formatCurrency(data.solds.amount) }} </template></Column
                    >
                    <Column field="solds" :header="$t('decont.totalAmount')">
                        <template #body="{ data }">{{ formatCurrency(data.solds.amountWithTax) }} </template></Column
                    >
                    <template #expansion="{ data }">
                        <DecontReport :shopId="shopsModel.id" :month="data.month" :year="yearModel.id"></DecontReport>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import { BoReportsApi } from '../../../../service/BoReportsApi';
import { BoApi } from '../../../../service/BoApi';
import { BoSaveReportsApi } from '../../../../service/BoSaveReportsApi';
import DecontReport from './DecontReport';

export default {
    name: 'decontShop',
    components: {
        DecontReport,
    },
    data() {
        return {
            BoApi: new BoApi(),
            BoReportsApi: new BoReportsApi(),
            BoSaveReportsApi: new BoSaveReportsApi(),
            yearModel: '',
            yearsDdl: [],
            shops: [],
            shopsModel: {},
            showReportData: false,
            showLoadingData: false,
            showDownloadingData: false,
            showGetDataBtn: false,
            errorKeyCount: 0,
            expandedRows: [],
        };
    },
    beforeMount() {
        let crtDate = new Date();
        let crtYear = crtDate.getFullYear();
        var startYear = this.getReportsStartYear();
        for (let i = startYear; i <= crtYear; i++) {
            var yearObj = { year: i, id: i };
            this.yearsDdl.push(yearObj);
            if (i === crtYear) {
                this.yearModel = yearObj;
            }
        }
        this.getShops();
    },
    watch: {
        shopsModel() {
            this.showReportData = false;
        },
        yearModel() {
            this.showReportData = false;
        },
    },
    methods: {
        getShops() {
            this.BoApi.getShops('')
                .then((shopsResponse) => {
                    let shopsDdlValues = [];
                    for (var i = 0; i < shopsResponse.data.length; i++) {
                        let shopItem = {
                            name: shopsResponse.data[i].code + ' - ' + shopsResponse.data[i].name,
                            id: shopsResponse.data[i]._id,
                        };
                        shopsDdlValues.push(shopItem);
                    }
                    this.shops = shopsDdlValues;
                })
                .catch((error) => {
                    this.checkForUnauthorizedError(error);
                    this.showToast('error', this.$t('alerts.generalError'));
                });
        },
        showReport() {
            if (this.notNullOrEmptyObject(this.shopsModel) && this.notNullOrEmptyObject(this.yearModel)) {
                this.BoReportsApi.getAnnualDecont(this.shopsModel.id, this.yearModel.id)
                    .then((response) => {
                        this.reportData = response.data;
                        this.showReportData = true;
                    })
                    .catch((error) => {
                        if (error.response && error.response.status === 401) {
                            this.$store.commit('login/endUserSession');
                            this.goto('login', { session: 'false' });
                        }
                    });
            } else {
                this.showToast('error', this.$t('alerts.invalidDdlFields'));
            }
        },
        savePdf() {
            if (this.notNullOrEmptyObject(this.shopsModel) && this.notNullOrEmptyObject(this.yearModel)) {
                this.showDownloadingData = true;
                this.BoSaveReportsApi.saveDecontAnnual(this.shopsModel.id, this.yearModel.id)
                    .then((response) => {
                        this.showDownloadingData = false;
                        let fileName = 'DecontAnualShop_' + this.shopsModel.name + '_' + this.yearModel.id + '.pdf';
                        let blob = new Blob([response.data], { type: 'application/pdf' });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                    })
                    .catch((error) => {
                        this.checkForUnauthorizedError(error);
                        this.showDownloadingData = false;
                        this.showToast('error', this.$t('alerts.generalError'));
                    });
            } else {
                this.showToast('error', this.$t('alerts.invalidDdlFields'));
            }
        },
        showToast(toastSeverity, text) {
            this.$toast.add({ severity: toastSeverity, summary: '', detail: text, life: this.getToastLifeSeconds() });
        },
    },
};
</script>
